module.exports = __webpack_public_path__ + "media/images/guide/keisan_club_guide_blue-bc334ae4de083e7e95528ffa78f2f4fd.png";